import Modal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`

h1{
    font-weight: 600;
}
.add-button{
    @media (max-width: 590px) {
        width: 90%;
    }
}


`
export const StyledReactModal = styled(Modal)`
      position: absolute;
      top: 50%;
      left: 50%;
      right: auto;
      bottom: auto;
      margin: auto;
      transform: translate(-50%, -50%);
      font-size: 2rem;
     
      border-radius: 2rem;
      background-color: white;
        @media (max-width: 500px) {
    width: 90%;
    padding: 1.5rem;
  }
  @media (max-width: 1200px) {
 
    margin-left: 2rem;

  }

`;
